import React, { Component } from 'react';
import LoadingComponent from '../global/loading-component';
import TranslatedCopy from '../../intl/translated-copy';
import { connect } from 'react-redux';
import { getErrorMessage } from '../../../redux/actions/index';

const mapStateToProps = state => ({
  apiWarning: state.Manage.apiWarning,
  apiError: state.Manage.apiError,
  errorMessageCms: state.ErrorMessage.errorMessageCms,
  errorMessageCmsFail: state.ErrorMessage.errorMessageCmsFail,
  loadingErrorMessage: state.ErrorMessage.loadingErrorMessage,
  loadingTraveler: state.Manage.loadingTraveler,
  isActiveFlowCorporate: state.Corporate.isActiveFlowCorporate,
  stateStoreFront: state.Manage.stateStoreFront,
  unredeemedVouchers: state.Manage.unredeemedVouchers,
});

class ErrorBar extends Component {
  constructor() {
    super();
  }

  componentWillMount() {
    const { apiError, apiWarning, language, dispatch } = this.props;
    if (apiWarning !== null && apiWarning.warnings.length > 0 && apiWarning?.warnings?.[0]?.code !== undefined) {
      dispatch(getErrorMessage(apiWarning?.warnings?.[0]?.code, language));
    } else {
      if (apiError !== null) {
        dispatch(getErrorMessage(apiError.errorData.code, language));
      }
    }
  }

  componentDidMount() {
    const {
      closeErrorBanner,
      loadingTraveler,
    } = this.props;

    if (!loadingTraveler) {
      setTimeout(closeErrorBanner, 6000);
    }
  }

  /* Rendering */
  render() {
    const {
      apiWarning,
      apiError,
      closeErrorBanner,
      errorMessageCms,
      isActiveFlowCorporate,
      loadingErrorMessage,
      stateStoreFront: {
        upgradeVoucherRedemptionMYB,
      },
      unredeemedVouchers,
    } = this.props;

    const errorMessage = errorMessageCms !== undefined && errorMessageCms !== null && errorMessageCms?.errorMessages?.length > 0
      ? errorMessageCms?.errorMessages?.[0]?.errorMessage?.copy : null;
    let copyErrorMessage = isActiveFlowCorporate ? 'MYB_CORP_CHANGE_CallCenter' : 'DEFAULT_ERROR_MESSAGE';
    // Check if there is a voucher unredeemed and if it is the case, change the error message
    if (upgradeVoucherRedemptionMYB && unredeemedVouchers.length > 0) {
      copyErrorMessage = 'MYB_COBR_UPGRADE_ERR.CONFIRM';
    }

    return (
      <div className='ErrorBar'>
        { !loadingErrorMessage ?
          <div>
            <div className='ErrorBar-content'>
              { errorMessage ?
                <p className='ErrorBar-description'>Error { apiWarning?.warnings?.[0]?.code || apiError?.errorData?.code } : { errorMessage }</p>
                :
                <TranslatedCopy copyID={copyErrorMessage} />
              }
            </div>
            <button
              className='ErrorBar-close Icon Icon--xThin'
              onClick={ () => closeErrorBanner() } />
          </div>
          : null }
      </div>
    );
  }

  renderCartExpirationWarning() {
    const { code } = this.props.incident;

    return (
      <div className='ErrorBar-content'>
        <TranslatedCopy
          className='ErrorBar-description'
          copyID={ code }
          tagName='p' />
      </div>
    );
  }

  renderErrorDescription() {
    const {
      errorMessage,
      incident: { code },
      loadingErrorMessage,
      storefrontData : { contactNumber },
    } = this.props;
    const parsedCode = code && parseInt(code, 10);
    const message = errorMessage ?
      <p className='ErrorBar-description'>
        { parsedCode >= 500000 && parsedCode <= 500500 ?
          <span>
            <span className='Icon Icon--club-premier ErrorBarProfile'></span>
            <TranslatedCopy copyID='ERROR_MESSAGE_CP' className='CP'/>.&nbsp;
          </span> : null
        }
        { errorMessage }
      </p> :
      <TranslatedCopy copyID='DEFAULT_ERROR_MESSAGE' phoneNumber={ contactNumber } />;
    this.setCloseErrorAgain(2000);
    return (
      <div className='ErrorBar-content'>
        { loadingErrorMessage ? <LoadingComponent /> : message }
      </div>
    );
  }

  renderWarnings() {
    const { warnings, warningMessages } = this.props;
    const warningCodes = warnings.collection && warnings.collection.map(warning => warning.code );
    let parsedWarnings = [];

    // this attempts to get translated error messages from the CMS, if it fails, it will settle with the warning codes from the API.
    try {
      parsedWarnings = warningMessages.map(message => message.errorMessages[0].errorMessage.copy);

      if (!parsedWarnings.length) {
        parsedWarnings = warningCodes;
      }
    } catch (e) {
      parsedWarnings = warningCodes;
      if (parsedWarnings.include('304041') ||
          parsedWarnings.include('304005') ||
          parsedWarnings.include('304002')) {
        return null;
      }
    }

    this.setCloseErrorAgain(3500); // cierra barra de error
    return (
      <div className='ErrorBar-content'>
        { parsedWarnings.map((msg, i) => {
          return (
            <p className='ErrorBar-description' key={ i }>{ msg }</p>
          );
        }) }
      </div>
    );
  }

  /* Event Handlers */

  // handleCloseClick() {
  //   const { dispatch } = this.props;
  //
  //   // dispatch(closeErrorBar());
  // }

  doNothing() {
    return false;
  }
}

ErrorBar = connect(mapStateToProps)(ErrorBar);

export default ErrorBar;
